module.exports = __webpack_public_path__ + "static/media/rebirth_22.fabb954b.jpg";